import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/site";

export default function MarqueeBand() {
  return (
    <section className="border-y border-slate-200 bg-slate-50 py-6 overflow-hidden" data-testid="marquee-band">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center" data-testid={`marquee-item-${i}`}>
            <span className="mx-10 font-serif italic text-2xl md:text-3xl text-slate-700 whitespace-nowrap">
              {item}
            </span>
            <svg width="18" height="18" viewBox="0 0 24 24" className="text-brand-green shrink-0" fill="currentColor" aria-hidden="true">
              <path d="M12 0l2.4 9.6L24 12l-9.6 2.4L12 24l-2.4-9.6L0 12l9.6-2.4z" />
            </svg>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
